export const ASSISTANT_URL = "https://tutoratest.asistentevirutalia.com"
// export const ASSISTANT_URL = "http://localhost:9000"
// nada

export const ASSISTANT_AUTH_LOGIN_URL = `${ASSISTANT_URL}/api/auth/login`;
export const ASSISTANT_AUTH_REGISTER_URL = `${ASSISTANT_URL}/api/auth/register`;

export const ASSISTANT_AUTH_GOOGLE_URL = `${ASSISTANT_URL}/api/auth/google`;
export const ASSISTANT_AUTH_MICROSOFT_URL = `${ASSISTANT_URL}/api/auth/microsoft`;

export const ASSISTANT_CHAT_HISTORY_URL = `${ASSISTANT_URL}/api/chat/history/s3`;
export const ASSISTANT_CHAT_SEND_URL = `${ASSISTANT_URL}/api/chat/send`;
export const ASSISTANT_REPORT_DOWNLOAD_URL = `${ASSISTANT_URL}/api/chat/report`;
